import { TermsOfService } from "PFApp/components/terms_of_service";
import { useAppShellStoreActions } from "PFApp/stores/app_shell_store";
import { Modal } from "PFComponents/modal";
import { useTranslation } from "react-i18next";

import css from "./terms_of_service_modal.module.scss";

export const TermsOfServiceModal = () => {
  const { t } = useTranslation();
  const { hideTerms } = useAppShellStoreActions();

  const handleClose = () => {
    hideTerms();
  };

  return (
    <Modal
      title={t("termsAndConditions")}
      onClose={handleClose}
      showOKButton={false}
      labelCancel={t("close")}
      classes={{ modal: css.modal }}
    >
      <TermsOfService />
    </Modal>
  );
};
